import * as yup from 'yup';


export const CAPTCHA_VALIDITY_MINUTES = 5;


// ------ field names for external reference
export const CAPTCHA_COMPLETED_AT_FIELD_NAME = 'captchaCompletedAt';
export const CAPTCHA_HAS_COMPLETED_FIELD_NAME = 'captchaIsCompleted';
export const CAPTCHA_IS_RUNNING_FIELD_NAME = 'captchaIsRunning';
export const CAPTCHA_SOLUTION_FIELD_NAME = 'captchaSolution';


export const CAPTCHA_FIELD_NAMES = [
    CAPTCHA_COMPLETED_AT_FIELD_NAME,
    CAPTCHA_HAS_COMPLETED_FIELD_NAME,
    CAPTCHA_IS_RUNNING_FIELD_NAME,
    CAPTCHA_SOLUTION_FIELD_NAME
];



// ------ form schema
export const SCHEMA_CAPTCHA_FORM = yup.object()
    .shape({
        [CAPTCHA_COMPLETED_AT_FIELD_NAME]: yup.string()
            .nullable()
            .required(),
        [CAPTCHA_SOLUTION_FIELD_NAME]: yup.string()
            .nullable()
            .required(),
        [CAPTCHA_HAS_COMPLETED_FIELD_NAME]: yup.boolean()
            .required()
            .default(false)
            .test('required', 'required', isChecked => isChecked === true),
        [CAPTCHA_IS_RUNNING_FIELD_NAME]: yup.boolean()
            .required()
            .default(false)
            .test('required', 'required', isChecked => isChecked === false)
    });
